import { CanvasElementType, CanvasObjectPosition, CanvasObjectSize, CanvasObjectStyles } from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles } from './default-canvas-model-properties';

const canvasPictureStylesDefaultConstant: CanvasObjectStyles = {
  ...defaultCanvasGenericStyles,
};

export function getCanvasPictureModel(data: {
  position: CanvasObjectPosition;
  size: CanvasObjectSize;
  imgUrl: string;
}) {
  return {
    type: CanvasElementType.Picture,
    styles: canvasPictureStylesDefaultConstant,
    position: data.position,
    size: data.size,
    typeSettings: { url: data.imgUrl },
  };
}

export type CanvasPictureModel = VisualizationCanvasElementStoreModel<CanvasElementType.Picture>;
